import RestClient from "../rest.client";

export default class PositionService {
    static async getPositions() {
        return await RestClient.call({
            url: '/positions',
            method: 'get',
            headers: { 'Authorization': localStorage.getItem('token') }
        })
    }

    static async getPositionsByDevice(deviceId: number, from: string, to: string) {
        return await RestClient.call({
            url: '/positions',
            method: 'get',
            params: {
                deviceId,
                from,
                to
            },
            headers: { 'Authorization': localStorage.getItem('token') }
        })
    }

}